import { color } from 'framer-motion';
import React from 'react';
import { colors } from '../color';

const Loader = ({ visible }) => {
    if (!visible) return null;

    const spinnerStyle = {
        width: 17,
        height: 17,
        border: '6px solid #f3f3f3',
        borderTop: '6px solid #3498db',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
    };

    const keyframes = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `;

    return (
       <div style={{
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '10px',
  width: '20%',
  height: '10%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(15, 23, 42, 0.9)',
  zIndex: 1000,
}}>
  <style>{keyframes}</style>
  <div style={{
    padding: 20,
    borderRadius: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }}>
    <div style={spinnerStyle}></div>
  </div>
</div>

    );
};

export default Loader;
